import { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useAuth } from "@/contexts/AuthContext";
import { useLive } from "@/contexts/LiveContext";
import { Flame, X } from "lucide-react";

export default function StreakBanner() {
  const { user, api } = useAuth();
  const { subscribe } = useLive();
  const [streak, setStreak] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  const load = useCallback(async () => {
    if (!user) { setStreak(null); return; }
    try { const { data } = await api.get("/streak/me"); setStreak(data); } catch {}
  }, [api, user]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => subscribe((msg) => { if (msg.type === "vote_update") load(); }), [subscribe, load]);

  const show = user && streak?.at_risk && !dismissed;
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: -12, height: 0 }}
          animate={{ opacity: 1, y: 0, height: "auto" }}
          exit={{ opacity: 0, y: -12, height: 0 }}
          className="overflow-hidden mb-5"
          data-testid="streak-banner"
        >
          <div className="flex items-center gap-3 px-4 py-3 rounded-xl text-white" style={{ background: "linear-gradient(120deg, #7c2d12 0%, #ea580c 70%, #f59e0b 130%)" }}>
            <motion.span animate={{ rotate: [-6, 6, -6], scale: [1, 1.1, 1] }} transition={{ duration: 1.4, repeat: Infinity }}>
              <Flame className="w-5 h-5 text-amber-200" fill="currentColor" />
            </motion.span>
            <p className="flex-1 text-sm">
              <b>Streak at risk!</b> Your {streak.current_streak}-day streak ends in ~{streak.hours_left}h — cast a vote below to keep it alive.
            </p>
            <button onClick={() => setDismissed(true)} className="p-1 text-white/70 hover:text-white" aria-label="Dismiss" data-testid="streak-banner-dismiss"><X className="w-4 h-4" /></button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
